/**
 * useTaskNodeHandlers - Event handlers for TaskNode
 */

import { useCallback } from 'react';
import { isPointerOverPortaledOverlayFromEvent } from '../../hooks/utils/overlayPointerGuard';

export function useTaskNodeHandlers({
  task,
  onMouseDown,
  onConnectionDragStart,
  connectionMenu,
}) {
  // Handle node mouse down (start drag)
  const handleNodeMouseDown = useCallback((e) => {
    if (isPointerOverPortaledOverlayFromEvent(e)) {
      return;
    }
    if (e.target.closest('.task-node__handle--bottom') ||
        e.target.closest('.mission-card__wait') ||
        e.target.closest('textarea') ||
        e.target.closest('.status-dropdown__trigger') ||
        e.target.closest('.status-dropdown__menu') ||
        e.target.closest('.task-node__status-btn') ||
        e.target.closest('.task-node__status-menu') ||
        e.target.closest('.task-node__category-btn') ||
        e.target.closest('.task-node__category-menu') ||
        e.target.closest('.task-node__tags-btn') ||
        e.target.closest('.task-node__tags-menu') ||
        e.target.closest('.mission-card__icon-btn') ||
        e.target.closest('.task-node__drag-menu') ||
        e.target.closest('.mission-card__name-input') ||
        e.target.closest('.task-node__resize-handle') ||
        e.target.closest('.task-node__quick-complete-btn') ||
        e.target.closest('.mission-card__toolbar-item') ||
        e.target.closest('.mission-card__attached-doc') ||
        e.target.closest('.open-in-view-dropdown__trigger') ||
        e.target.closest('.open-in-view-dropdown__menu')) {
      return;
    }
    onMouseDown?.(e);
  }, [onMouseDown]);

  // Connection handle handlers
  const handleConnectionHandleClick = useCallback((e) => {
    connectionMenu.openMenu(e);
  }, [connectionMenu]);

  const handleConnectionHandleMouseDown = useCallback((e) => {
    e.stopPropagation();
    onConnectionDragStart?.(e);
  }, [onConnectionDragStart]);

  return {
    // Handlers
    handleNodeMouseDown,
    handleConnectionHandleClick,
    handleConnectionHandleMouseDown,
  };
}

export default useTaskNodeHandlers;
